import {BaseEntity} from "./BaseEntity";
import { Company } from "./Company";


export class PrintClient implements  BaseEntity
{
    companies: Company[] = [];
    constructor(public id?: number,
        public name?: string,
        public username?: string,
        public password?: string,
        public lastSeen?: string,
        public machineName?: string
        
    ) {
    }

    parseJson(json: any): void {
        this.id = json.id;
        this.name = json.name;
        this.username = json.username;
        this.password = json.password;
        this.lastSeen = json.lastSeen;
        this.machineName = json.machineName;
        this.companies = [];
        for (var i = 0; i < json.companies.length; i++) {
            var tempCompany = new Company();
            tempCompany.parseJson(json.companies[i]);
            this.companies.push(tempCompany);            
        }
    }
}
